// LabelStore.ts
type LabelListener = (label: string) => void;

class LabelStore {
  private label = 'Dashboard';
  private listeners: LabelListener[] = [];

  getLabel() {
    return this.label;
  }

  updateLabel(newLabel: string) {
    this.label = newLabel;
    this.listeners.forEach(listener => listener(this.label));
  }

  subscribe(listener: LabelListener) {
    this.listeners.push(listener);
    listener(this.label); // call immediately
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }
}

export const labelStore = new LabelStore();
